import { Component, OnInit } from "@angular/core";
import { InternationalService } from "@root/international.service";
import { NzModalRef } from "ng-zorro-antd/modal";

@Component({
  selector: "host-airbnb-auth-requirement",
  templateUrl: "./airbnb-auth-requirement.component.html",
  styleUrls: ["./airbnb-auth-requirement.component.scss"],
})
export class AirbnbAuthRequirementComponent implements OnInit {
  get isInternational() {
    return this.international.isInternational();
  }

  constructor(
    private international: InternationalService,
    private modalRef: NzModalRef
  ) {}

  ngOnInit() {}

  closeModal() {
    this.modalRef.destroy("OK");
  }
}
